import React, {Component} from "react";
import UploadUserImageForm from "../../../../components/Forms/UploadUserImageForm/UploadUserImageForm.jsx";
import {Link} from "react-router-dom";
import {generate} from "../../../../routes.js";
import SubmitButton from "../../../../components/Forms/ProfilePresentationForm/SubmitButton.jsx";
import ProfilePresentationForm from "../../../../components/Forms/ProfilePresentationForm/ProfilePresentationForm.jsx";
import {prepareFreelanceBeforeSubmit} from "../../../../../shared/services/freelanceService.js";
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

class ProfilePresentation extends Component {
  onUploadSuccess = (image) => {
    this.props.refresh({
      user: {
        ...this.props.user,
        image,
      },
      freelance: {
        ...this.props.freelance,
        image,
      },
    });
  };

  submit = (values) => {
    const {user} = values
    const userData = {
      lastname: user.lastname,
      firstname: user.firstname,
      tel: user.tel,
      email: user.email,
      date_of_birth: user.date_of_birth,
      company: user.company,
      company_type: user.company_type,
      linkedin_url: user.linkedin_url,
    }
    this.props.submit({
      user: userData,
      freelance: prepareFreelanceBeforeSubmit(values.freelance)
    });
  };

  render() {
    const {
      freelance,
      user,
    } = this.props

    return (
      <FreelancePage className="step-general-pres">
        <h2 className="text-center">Présentation du profil</h2>

        {this.props.user && this.props.freelance &&
            <div>
              <div id="pres-profile-picture" className="row justify-content-center my-account-profile-image">
                <div className="col-xl-10">
                  <UploadUserImageForm
                    title="Photo de profil"
                    image={this.props.user.image}
                    userId={this.props.user.id}
                    onUploadSuccess={this.onUploadSuccess}>
                  </UploadUserImageForm>
                </div>
              </div>
              <ProfilePresentationForm
                isAdmin={this.props.isAdmin}
                enableReinitialize={true}
                onSubmit={this.submit}
                initialValues={{
                  user: user,
                  freelance: freelance
                }}
                onSubmitSuccess={this.props.onFormSuccess}/>
            </div>
        }
        {this.props.create &&
            <div className="mt-5 d-flex flex-wrap align-items-center">
              <div className="mr-auto">
                <Link to={generate({name: 'homepage'})} className="gray">
                  Je finirai plus tard (ne pas sauvegarder)
                </Link>
              </div>
              <SubmitButton className="btn btn-primary ml-auto">Étape suivante</SubmitButton>
            </div>}
        {this.props.edit &&
          <div className="mt-5 d-flex">
            <SubmitButton className="mx-auto btn btn-primary">Sauvegarder</SubmitButton>
          </div>
        }
      </FreelancePage>
    );
  }
}

export default ProfilePresentation